import React from 'react';
import ProductPatternPage from './ProductPatternPage';
import './CabbagePage.css';
import cabbageLogo from '../images/cabbage-logo.png';

const varieties = [

];

export default function CabbagePage() {
  return <ProductPatternPage title="Cabbage" varieties={varieties} pageClass="cabbage-page" heroImage={cabbageLogo} />;
}
